/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import styles from './index.scss';

const IconClose = ({ fill, className, width, height, onClick }) => (
    <svg
        className={`apc-svg-icon ${styles.iconClose} ${className}`}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        onClick={onClick}
    >
        <path
            d="M27.828 26l14.143 14.142a1 1 0 0 1 0 1.414l-1.415 1.415a1 1 0 0 1-1.414 0L25 28.828 10.858 42.971a1 1 0 0 1-1.414 0l-1.415-1.415a1 1 0 0 1 0-1.414L22.172 26 8.029 11.858a1 1 0 0 1 0-1.414l1.415-1.415a1 1 0 0 1 1.414 0L25 23.172 39.142 9.029a1 1 0 0 1 1.414 0l1.415 1.415a1 1 0 0 1 0 1.414L27.828 26z"
            fill={fill}
            fillRule="evenodd"
        />
    </svg>
);

IconClose.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    onClick: PropTypes.func,
};

IconClose.defaultProps = {
    fill: '#FFF',
    className: '',
    width: 20,
    height: 20,
    onClick: () => {},
};

export default IconClose;
